import progressBar from './progress-bar.json' with { type: 'json' };

export default {
  progress_bar: progressBar,
};
